import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateService } from '@ngx-translate/core';

@Injectable()
export class FallbackTranslationHandler implements MissingTranslationHandler {
    public handle(params: MissingTranslationHandlerParams): string {
        const { key, interpolateParams } = params;
        const ts: TranslateService = params.translateService;

        // 1) Get English bundle that we preloaded at boot
        const enBundle = ts.store?.translations?.['en'];

        // 2) Pull the raw value from EN *without* triggering the handler
        //    Use the parser directly (no network, no handler)
        let raw = enBundle ? ts.parser.getValue(enBundle, key) : undefined;

        // 3) If EN missing too, try the default bundle (if it’s not 'en')
        if ((raw === undefined || raw === null) && ts.getDefaultLang && ts.getDefaultLang() !== 'en') {
            const defLang = ts.getDefaultLang();
            const defBundle = ts.store?.translations?.[defLang as string];
            if (defBundle) {
                raw = ts.parser.getValue(defBundle, key);
            }
        }

        // 4) If still missing, return the key (visible hint to add translation)
        if (raw === undefined || raw === null) {
            return key;
        }

        // 5) Interpolate only if it’s a string
        if (typeof raw === 'string') {
            return ts.parser.interpolate(raw, interpolateParams) as string;
        }

        // If the EN value is an object/array, ngx-translate would normally return the object.
        // Decide your policy. Commonly, return key so UI doesn’t render [object Object].
        return key;
    }
}
